import React from 'react';
import companyInfo from '../data/companyInfo.json';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        
        {/* COMPANY INFO */}
        <div className="footer-section">
          <h3>About MaxInfra</h3>
          <p>{companyInfo.company_name}</p>
          <p className="tagline">{companyInfo.tagline}</p>
        </div>

        {/* QUICK LINKS */}
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="#home">Home</a></li>
            <li><a href="#about">About Us</a></li>
            <li><a href="#services">Business Verticals</a></li>
            <li><a href="#projects">Projects</a></li>
            <li><a href="#contact">Contact Us</a></li>
          </ul>
        </div>

        {/* CONTACT INFO */}
        <div className="footer-section">
          <h3>Contact Us</h3>
          <p>
            <strong>Address:</strong><br />
            {companyInfo.address}
          </p>
          <p>
            <strong>Phone:</strong><br />
            <a href={`tel:${companyInfo.phone}`}>{companyInfo.phone}</a>
          </p>
          <p>
            <strong>Email:</strong><br />
            <a href={`mailto:${companyInfo.email}`}>{companyInfo.email}</a>
          </p>
        </div>

        {/* WORKING HOURS */}
        <div className="footer-section">
          <h3>Working Hours</h3>
          <p>
            <strong>Monday - Saturday</strong><br />
            9:30 AM - 6:00 PM
          </p>
          <p>
            <strong>Sunday</strong><br />
            Closed
          </p>
        </div>

      </div>

      {/* FOOTER BOTTOM */}
      <div className="footer-bottom">
        <p>&copy; 2026 MAX INFRA (I) PRIVATE LIMITED. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;